<template>
  <div class="container-fluid pt-0 row mx-0 bg-primary">
    <article class="card col-lg-10 mx-auto my-4 mycard-scale">
      <div class="card-body">
        <page-breadcrumb :items="crumbs" />
        <h1 class="h3 card-title">桂运宝公司新闻</h1>
        <p class="p2em">
          广西桂运宝科技有限公司总部在柳州，从事大宗货物网络货运。这里发布公司新闻与业务进展。新闻接口暂时无法访问时，请先阅读
          <router-link to="/about">公司简介</router-link>
          和
          <router-link to="/news">平台检查纪实</router-link>
          。
        </p>
        <p v-if="loadError" class="text-muted">暂时无法获取最新列表。</p>
        <div v-for="item in newslist" :key="item.id" class="border-top pt-3 mt-3">
          <router-link
            :to="{ name: 'newsdetail', params: { id: item.id } }"
            class="text-info"
          >
            <h2 class="h5 card-title text-primary">{{ item.title }}</h2>
          </router-link>
          <p class="card-text fs-6 fw-lighter">
            发布于
            <span class="text-muted">{{ item.publish }}</span>
          </p>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import axios from "axios";
import { PAGES } from "@/seo/site";

/**
 * 公司新闻列表。接口失败时保留静态说明，不跳走。
 */
export default {
  name: "ournews",
  data: function () {
    return {
      crumbs: PAGES.companynews.crumbs,
      newslist: [],
      loadError: false,
    };
  },
  mounted: function () {
    axios
      .get(this.$backend_url + "ournews/", { timeout: 8000 })
      .then((res) => {
        if (!res.data || res.data.length === 0) {
          this.loadError = true;
          return;
        }
        this.newslist = res.data.map((mydata) => {
          const time = new Date(mydata.fields.publish);
          return {
            id: mydata.pk,
            title: mydata.fields.title,
            author: mydata.fields.author,
            content: mydata.fields.content,
            publish: time.toLocaleString("zh-CN"),
          };
        });
      })
      .catch(() => {
        this.loadError = true;
      });
  },
};
</script>
